import { Menu, Modal } from 'antd';
import moment from 'moment';
import * as React from 'react';
import { deleteTerminationRequest, getTerminationRequest, setTerminationRequest } from '../../apis/Terminations';
import SetTerminationModal from './SetTerminationModal';

interface ILocalProps {
    companyID: number,
    companyName: string,
    terminationRequestID: number | null,
    onChange: () => void,
};

interface ILocalState {
    companyID: number,
    companyName: string,
    note: string,
    openSetModal: boolean,
    requestDate: moment.Moment,
    terminationDate: moment.Moment,
    terminationRequestID: number | null,
};

class TerminationMenuItem extends React.Component<ILocalProps, ILocalState> {
    public constructor(props: any) {
        super(props);

        // Set the initial local state
        this.state = {
            companyID: props.companyID,
            companyName: props.companyName,
            note: '',
            openSetModal: false,
            requestDate: moment(),
            terminationDate: moment(),
            terminationRequestID: props.terminationRequestID,
        }
    }

    public async componentWillMount() {
        if (this.state.terminationRequestID) {
            const terminationRequest = await getTerminationRequest(this.state.terminationRequestID);
            this.setState({
                note: terminationRequest.note ? terminationRequest.note.content : '',
                requestDate: moment(terminationRequest.requestDate),
                terminationDate: moment(terminationRequest.terminationDate),
            });
        }
    }

    public openSetTerminationModal = () => {
        this.setState({openSetModal: true});
    }

    public closeSetTerminationModal = () => {
        this.setState({openSetModal: false});
    }

    public openRemoveTerminationModal = () => {
        Modal.confirm({
            content: 'Are you sure you would like to cancel this termination request?',
            onOk: this.onDeleteTerminationRequest,
            title: `Cancel Termination Request for ${this.state.companyName} (${this.state.companyID})`,
        })
    }

    public onRequestDateChange = (date: moment.Moment, dateString: string) => {
        this.setState({requestDate: date});
    }

    public onTerminationDateChange = (date: moment.Moment) => {
        this.setState({terminationDate: date});
    }

    public onNoteChange = (e: any) => {
        this.setState({note: e.target.value});
    }

    public onDeleteTerminationRequest = async () => {
        const terminationRequestID = this.state.terminationRequestID || 0;
        if (!terminationRequestID) {
            this.onCancel();
            return;
        }
        const done = await deleteTerminationRequest(terminationRequestID);

        this.setState({
            note: '',
            requestDate: moment(),
            terminationDate: moment(),
            terminationRequestID: null,
        });
        this.props.onChange();
        return done;
    }

    public onCancel = () => {
        this.setState({
            openSetModal: false,
        });
    }

    public onSave = async () => {
        const terminationRequestID = await setTerminationRequest(
            this.state.companyID,
            this.state.terminationRequestID,
            this.state.requestDate.format('YYYY-MM-DD'),
            this.state.terminationDate.format('YYYY-MM-DD'),
            this.state.note
        );
        this.setState({terminationRequestID});
        this.props.onChange();
        this.onCancel();
    }


    public render() {
        if (this.state.terminationRequestID) {
            return (
                <Menu selectable={false}>
                    <Menu.Item onClick={this.openRemoveTerminationModal}>
                        Cancel Termination Request
                    </Menu.Item>
                    <Menu.Item onClick={this.openSetTerminationModal}>
                        Edit Termination Request
                    </Menu.Item>

                    {this.state.openSetModal &&
                        <SetTerminationModal
                            companyID={this.state.companyID}
                            companyName={this.state.companyName}
                            onRequestDateChange={this.onRequestDateChange}
                            onTerminationDateChange={this.onTerminationDateChange}
                            onNoteChange={this.onNoteChange}
                            onCancel={this.onCancel}
                            onSave={this.onSave}
                            requestDate={this.state.requestDate}
                            terminationDate={this.state.terminationDate}
                            note={this.state.note}
                        />
                    }
                </Menu>
            );
        } else {
            return (
                <Menu selectable={false}>
                    <Menu.Item onClick={this.openSetTerminationModal}>
                        Create Termination Request
                    </Menu.Item>
                    {this.state.openSetModal &&
                        <SetTerminationModal
                            companyID={this.state.companyID}
                            companyName={this.state.companyName}
                            onRequestDateChange={this.onRequestDateChange}
                            onTerminationDateChange={this.onTerminationDateChange}
                            onNoteChange={this.onNoteChange}
                            onCancel={this.onCancel}
                            onSave={this.onSave}
                            requestDate={this.state.requestDate}
                            terminationDate={this.state.terminationDate}
                            note={this.state.note}
                        />
                    }
                </Menu>
            );
        }
    }
}

export default TerminationMenuItem;
